import styles from './styles';

import * as React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { CardMedia, withStyles } from '@material-ui/core';
import type * as CSS from 'csstype';

interface IProps extends WithStyles<typeof styles> {
  imageUrl?: string;
  colour?: string;
  className?: string;
}

@observer
class ConnectCardMedia extends React.Component<IProps> {
  render() {
    const { imageUrl } = this;
    const { classes } = this.props;

    if (!imageUrl) {
      return <CardMedia className={this.className} style={this.backgroundStyles} component="div" />;
    }

    return (
      <CardMedia
        className={classes.image}
        style={this.backgroundStyles}
        component="img"
        image={this.imageUrl}
      />
    );
  }

  @computed
  private get className(): string {
    const { className, classes } = this.props;

    if (!className) {
      return classes.image;
    }

    return [classes.image, className].join(' ');
  }

  @computed
  private get backgroundStyles(): CSS.Properties {
    const { colour, imageUrl } = this.props;
    if (!colour || !!imageUrl) {
      return undefined;
    }

    return {
      backgroundColor: colour
    };
  }

  @computed
  private get imageUrl(): string | undefined {
    const { imageUrl } = this.props;

    if (!imageUrl) {
      return undefined;
    }

    const index = imageUrl.lastIndexOf('/');
    const image = index === -1 ? imageUrl : imageUrl.substring(index);

    return `/api/online/files/bypath/${image}`;
  }
}

export default withStyles(styles)(ConnectCardMedia);
